import { useState, useEffect } from "react";
import { mdiChevronDoubleDown } from "@mdi/js";
import Icon from "@mdi/react";

const DoubleDownChevron = ({ onClick }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const box = document.documentElement;
      const scrollPosition = box.scrollTop;
      const boxHeight = box.clientHeight;
      const threshold = boxHeight * 0.1;

      setIsVisible(scrollPosition < threshold);
    };

    document.documentElement.addEventListener("scroll", handleScroll);

    return () => {
      document.documentElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return isVisible ? (
    <Icon
      path={mdiChevronDoubleDown}
      size={2}
      color="rgba(255, 255, 255, 0.8)"
      className="wave-icon"
      onClick={onClick}
    />
  ) : null;
};

export default DoubleDownChevron;
